import useRoutes from '../../../hooks/useRoutes';

type FromUrlRoutes = Pick<
  ReturnType<typeof useRoutes>,
  'dashboards' | 'datasetList'
>;

const resolveFromUrl = (
  datasetId: string,
  menuFromUrl: string | undefined,
  routes: FromUrlRoutes
): string => {
  if (datasetId) {
    return routes.datasetList(datasetId);
  }
  if (menuFromUrl && !menuFromUrl.includes('/form/')) {
    return menuFromUrl;
  }
  return routes.dashboards();
};

export default resolveFromUrl;
